// Autogenerated file
export const shippingDocumentProviderTypesEnum = {
    ProviderEmulator: "ProviderEmulator",
    Astral: "Astral",
    Kontur: "Kontur",
};
export const shippingDocumentProviderTypes = [
    { label: "ProviderEmulator", value: "ProviderEmulator", intValue: 0 },
    { label: "Astral", value: "Astral", intValue: 1 },
    { label: "Kontur", value: "Kontur", intValue: 2 },
];
